module.exports = __webpack_public_path__ + "static/media/tofy.9fc1ee29.png";